"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentingMomentRebrand = exports.ParentingMoment = void 0;
var ParentingMoment;
(function (ParentingMoment) {
    ParentingMoment["PARENTS_TO_BE"] = "PARENTS_TO_BE";
    ParentingMoment["NEWBORNS"] = "NEWBORNS";
    ParentingMoment["BABIES"] = "BABIES";
    ParentingMoment["TODDLERS"] = "TODDLERS";
    ParentingMoment["YOUNG_CHILDREN"] = "YOUNG_CHILDREN";
    ParentingMoment["ADULTS"] = "ADULTS";
    ParentingMoment["SENIORS"] = "SENIORS";
})(ParentingMoment || (exports.ParentingMoment = ParentingMoment = {}));
var ParentingMomentRebrand;
(function (ParentingMomentRebrand) {
    ParentingMomentRebrand["FAMILIES"] = "FAMILIES";
    ParentingMomentRebrand["PARENTS_TO_BE"] = "PARENTS_TO_BE";
    ParentingMomentRebrand["PARENT_AND_CHILD"] = "PARENT_AND_CHILD";
    ParentingMomentRebrand["NEWBORNS_TO_TODDLERS"] = "NEWBORNS_TO_TODDLERS";
    ParentingMomentRebrand["CHILDREN"] = "CHILDREN";
    ParentingMomentRebrand["YOUTH"] = "YOUTH";
    ParentingMomentRebrand["ADULTS"] = "ADULTS";
    ParentingMomentRebrand["SENIORS"] = "SENIORS";
})(ParentingMomentRebrand || (exports.ParentingMomentRebrand = ParentingMomentRebrand = {}));
//# sourceMappingURL=parenting-moment.js.map